import { useEffect } from 'react';
import { MediaResult, NativeMessage, AddToCalendarResult, VersionSyncInfo } from '@/types/nativeBridge.types';

export function useNativeMessages(
  onCameraResult?: (result: MediaResult) => void,
  onGalleryResult?: (result: MediaResult) => void,
  onAddToCalendarResult?: (result: AddToCalendarResult) => void,
  onRemoveFromCalendarResult?: (result: AddToCalendarResult) => void,
  onUpdateCalendarEventResult?: (result: AddToCalendarResult) => void,
  onVersionSyncStatus?: (info: VersionSyncInfo) => void
) {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('[Web] Received message:', event.data);
      
      try {
        const data: NativeMessage = typeof event.data === 'string' 
          ? JSON.parse(event.data) 
          : event.data;

        console.log('[Web] Parsed message type:', data.type);

        if (data.type === 'open_camera_result') {
          console.log('[Web] Camera result:', data.payload);
          onCameraResult?.(data.payload as MediaResult);
        }
        
        if (data.type === 'open_gallery_result') {
          console.log('[Web] Gallery result:', data.payload);
          onGalleryResult?.(data.payload as MediaResult);
        }

        if (data.type === 'add_to_calendar_result') {
          console.log('[Web] Add to calendar result:', data.payload);
          onAddToCalendarResult?.(data.payload as AddToCalendarResult);
        }

        if (data.type === 'remove_from_calendar_result') {
          console.log('[Web] Remove from calendar result:', data.payload);
          onRemoveFromCalendarResult?.(data.payload as AddToCalendarResult);
        }

        if (data.type === 'update_calendar_event_result') {
          console.log('[Web] Update calendar event result:', data.payload);
          onUpdateCalendarEventResult?.(data.payload as AddToCalendarResult);
        }

        if (data.type === 'version_sync_status') {
          console.log('[Web] Version sync status:', data.payload);
          onVersionSyncStatus?.(data.payload as VersionSyncInfo);
        }
      } catch (err) {
        console.error('[Web] Error parsing native message:', err);
      }
    };

    // BOTH listeners needed for cross-platform support
    // iOS uses window.addEventListener
    // Android uses document.addEventListener
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage as any);

    return () => {
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage as any);
    };
  }, [onCameraResult, onGalleryResult, onAddToCalendarResult, onRemoveFromCalendarResult, onUpdateCalendarEventResult, onVersionSyncStatus]);
}
